import angular from 'angular';
import uiRouter from 'angular-ui-router';

import FaqComponent from './faq.component';

const faqModule = angular.module('tinaba.components.faq', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('faq', {
      url: '/faq',
      template: '<faq></faq>'
    });
})

.component('faq', FaqComponent);

export default faqModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/faq/faq.js
 **/